import api from "./api";

export const getMyNavigationMenu = async () => {
    const response = await api.get("/NavigationMenu/my");
    return response.data;
};